import { Component } from '@angular/core';
import { GlobalService } from '../global.service';

@Component({
  selector: 'app-maser-page-header',
  templateUrl: './maser-page-header.component.html',
  styleUrls: ['./maser-page-header.component.scss']
})
export class MaserPageHeaderComponent {

  constructor(public global: GlobalService) { }

}
